<template>
  <section>
    <!-- Header -->
    <left-menu />

    <div id="mainContent" class="location-point-content">
      <loading-page v-if="loading" />

      <div v-else class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">Localização do ponto</h1>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12  offset-top-30">
          <div id="map" class="wow fadeInRight" data-wow-delay="0.6s"></div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
  import leftMenu from '../../components/leftMenu.vue';
  import loadingPage from "../../components/loadingPage";

  import vueFooter from "../../components/footer";
  import { GMAPS_UTIL_SERVICE } from "../../../../gMapsUtils";

  export default {
    name: "request-adjustment",
    components: {
      leftMenu,
      loadingPage,
      vueFooter
    },
    data() {
      return {
        loading: false,
        pointLocation: ""
      }
    },
    methods: {
      initMap() {
        // map = new google.maps.Map(document.getElementById('map'));
        setTimeout(() => {
          console.log(parseFloat(this.pointLocation.lat), "this.pointLocation");

          GMAPS_UTIL_SERVICE.initMap(parseFloat(this.pointLocation.lat), parseFloat(this.pointLocation.lng));

          GMAPS_UTIL_SERVICE.addMarker(parseFloat(this.pointLocation.lat), parseFloat(this.pointLocation.lng));
        }, 1000);

      }
    },
    beforeMount() {
      this.pointLocation = JSON.parse(window.localStorage.getItem('pointRegisterLatLng'));
      this.initMap(this.pointLocation.lat, this.pointLocation.lng);
    },
  }
</script>

<style lang="scss">
  #map {
    height: 450px !important;
    margin-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/showLocationInMap/showLocationInMap.vue